const Heading = () => {
  return (
    <div className="d-flex flex-column">
      <h1 className="m-2 p-2 text-center main-heading">
        Английский для тех, кому он был нужен ещё вчера - без "воды", суеты, скуки и зубрёжки
      </h1>
    </div>
  )
};

export default Heading;